export default [
  {
    key: 'company',
    value: '',
    label: 'アライアンス名',
    rules: {},
    name: 'company',
    as: 'select',
    disabled: true,
    options: [],
  },
  {
    key: 'admin_name',
    value: '',
    label: 'マネージャID',
    rules: { requiredWithFormat: true, adminID: true },
    name: 'administratorId',
    as: 'input',
    disabled: false,
  },
  {
    key: 'admin_display_name',
    value: '',
    label: 'マネージャ名',
    rules: { required: true, max: 100 },
    name: 'adminDisplayName',
    as: 'input',
    disabled: false,
  },
  {
    key: 'password',
    value: '',
    label: 'パスワード',
    rules: {},
    name: 'password',
    as: 'input',
    type: 'password',
  },
  {
    key: 'password_2',
    value: '',
    label: 'パスワード(確認）',
    rules: {},
    name: 'passwordConfirm',
    as: 'input',
    type: 'password',
  },
  {
    key: 'level',
    value: '',
    label: 'マネージャタイプ',
    rules: { required: true },
    as: 'select',
    options: [],
    disabled: false,
  },
]
